import React from "react";
import { ArrowBackCircle } from "react-ionicons";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "@popperjs/core";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import constantURI from "../URI";
import stylesASAP from "./stylesASAP";
import _post from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilter";
import ASAPAuthenticate from "../Functions/ASAPAuthenticate";
import stylesMed from "../MedRep/stylesMed";
import { db, getDocs, collection, disableNetwork } from "../firebase";
import { set, get } from "idb-keyval";
import ReactToPrint from "react-to-print";
import { forwardRef } from "react";

import { PieChart, Pie, Legend, Tooltip, ResponsiveContainer } from "recharts";

export default class ReportsAsap extends React.Component {
  constructor() {
    super();
    this.state = {
      authenticate: false,
      fromDate: new Date(),
      toDate: new Date(),
      showAlert: false,
      clients: [],
      showClients: false,
      selectedClient: 0,
      disableClient: false,
      getButton: true,
      loading: false,
      showRequiredAlert: false,
      alertString: "",
      requiredFields: { fromDate: true, toDate: true },
      noData: true,
      clientsCopy: [],
      alertOffline: false,
      token: "",
      customer: "",
      alertUndefined: false,
      nodata: false,
      userId: -1,
      selectedType: 0,
      clientIndex: -1,
      clickedButton: 0,
      isChecked: false,
      Total: 0,
      TotalRO: 0,
      TotalCSH: 0,
      UST: [],
      Visited: [],
      OutVisited: [],
      SalesObject: {},
      SR: [],
      loading: true,
      temp: [],
      temp1: [],
      temp2: [],
      temp3: [],
      types: [
        {
          name: "Local Transactions",
          Headers: ["name", "ClientName", "Total"],
        },
        {
          name: "Local Daily Summary",
          Headers: ["Description", "Value"],
        },
        {
          name: "Local Collection",
          Headers: ["#Receipt", "clientCode", "client", "Amount"],
        },
        {
          name: "Local Out-Of-Route Visits",
          Headers: ["ClientName", "Time In", "Time Out", "Visit"],
        },
        {
          name: "Local Routed Visits",
          Headers: [
            
            "ClientName",
            "Time In",
            "Time Out",
            "Visit",
            "Invoiced",
          ],
        },
        {
          name: "Item Sales Report ",
          Headers: ["Item name", "Quantity ","Free Item", "Total"],
        },
        {
          name: "Competitor Logs",
          Headers: [
            "Competitor",
            "Category",
            "Product",
            "Shelf %",
            "Price",
            "Promotions",
            "Notes",
            "Logged At",
          ],
        },
      ],
      scheduledReport: [],
      CurrentId: 0,
      Data: [],
      selectedItemId: null,

      dailySummaryReport: [],
      localDailyVisits: [],
      competitorLogs: [],
    };
    // this.printableDivRef = React.createRef();
    this.printableRef = React.createRef();
    this.printable2Ref = React.createRef();
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";

    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    const username = JSON.parse(localStorage.getItem("Username"));
    this.setState({ username: username });
    const token = localStorage.getItem("Token");
    const userId = localStorage.getItem("UserId");
    const UST = JSON.parse(localStorage.getItem("DailyData"));
    const CurrentId = JSON.parse(localStorage.getItem("ReportId"));
    const dailySummaryReport = JSON.parse(
      localStorage.getItem("DailySummaryReport")
    );
    const localDailyVisits = JSON.parse(
      localStorage.getItem("LocalDailyVisits")
    );
    const Visited = JSON.parse(localStorage.getItem("VisitIn"));
    const OutVisited = JSON.parse(localStorage.getItem("backupVisits"));
    const scheduled = JSON.parse(localStorage.getItem("ScheduledClients"));
    let competitorLogs = [];
    try {
      const storedCompetitorLogs = localStorage.getItem("competitorLogs");
      competitorLogs = storedCompetitorLogs ? JSON.parse(storedCompetitorLogs) : [];
    } catch (error) {
      competitorLogs = [];
    }

    await this.setState({
      token: JSON.parse(token),
      userId: JSON.parse(userId),
      UST: UST,
      CurrentId: CurrentId,
      dailySummaryReport: dailySummaryReport,
      localDailyVisits: localDailyVisits,
      loading: false,
      Visited: Visited,
      OutVisited: OutVisited,
      scheduled: scheduled,
      competitorLogs: competitorLogs,
    });
    //ReadClients from indexDB
    this.itemSales();
    if (
      this.state.UST &&
      this.state.UST.length !== 0 &&
      this.state.UST[0] !== null
    ) {
      let total = this.state.Total; // Initialize with the current total

      this.state.UST[0].forEach((order) => {
        var date_test = new Date(order.date_order);
        console.log(date_test.toISOString().split("T")[0]); // Logs the full date in YYYY-MM-DD format

        // Convert this.state.fromDate and this.state.toDate to full dates
        const fromDate = new Date(this.state.fromDate);
        const toDate = new Date(this.state.toDate);

        console.log(fromDate.toISOString().split("T")[0]); // Logs full fromDate in YYYY-MM-DD format
        console.log(toDate.toISOString().split("T")[0]); // Logs full toDate in YYYY-MM-DD format

        // Compare the dates
        if (
          fromDate.toISOString().split("T")[0] <=
            date_test.toISOString().split("T")[0] &&
          toDate.toISOString().split("T")[0] >=
            date_test.toISOString().split("T")[0]
        ) {
          // total += parseFloat(order.taxedAmount) || 0;
          total += parseFloat(order.taxedAmount.replace(/,/g, "")) || 0;
        }
      });

      // Update the state once with the final accumulated total
      this.setState({ Total: total });
    }
   

    const report =
      Visited !== null && Visited !== undefined
        ? Visited.map((v) => ({
            ...v,
          }))
        : [];
        const safeVisited = Visited ?? [];

const missing = scheduled
  .filter((s) => !safeVisited.some((v) => v.id === s.id))
  .map((s) => ({
    ...s,
    code: "",
    dateIn: s.start.split(" ")[0],
    timeIn: "00:00:00",
    dateOut: 0,
    timeOut: 0,
    visit: "Non visited",
    countTrans: 0,
  }));
    // const missing = scheduled
    //   .filter((s) => !Visited.some((v) => v.id === s.id))
    //   .map((s) => ({
    //     ...s,
    //     code: "",
    //     dateIn: s.start.split(" ")[0],
    //     timeIn: "00:00:00",
    //     dateOut: 0,
    //     timeOut: 0,
    //     visit: "Non visited",
    //     countTrans: 0,
    //   }));

    await this.setState({
      scheduledReport: [...report, ...missing],
    });

    console.log(this.state.scheduledReport);
    if (
      this.state.UST[1] !== undefined &&
      this.state.UST[1] !== null &&
      this.state.UST[1].length !== 0
    ) {
      let total = this.state.TotalRO; // Initialize with the current total

      this.state.UST[1].forEach((order) => {
        const today = new Date();
        const orderDate = new Date(order.date_order);

        if (orderDate.toDateString() === today.toDateString()) {
          total += parseFloat(order.taxedAmount.replace(/,/g, "")) || 0;
        }
      });

      // Update the state once with the final accumulated total
      this.setState({ TotalRO: total });
    }

    if (this.state.UST[5] !== undefined && this.state.UST[5].length !== 0) {
      let total = this.state.TotalCSH; // Initialize with the current total

      this.state.UST[5].forEach((order) => {
        const today = new Date();
        const orderDate = new Date(order.date_order);

        if (orderDate.toDateString() === today.toDateString()) {
          total += parseFloat(order.taxedAmount.replace(/,/g, "")) || 0;
        }
      });

      // Update the state once with the final accumulated total
      this.setState({ TotalCSH: total });
    }

    // Get today's date
    const today = new Date();

    // Map through the array and filter based on date
    if (this.state.UST[0] !== undefined && this.state.UST[0] !== null) {
      const filteredOrders = this.state.UST[0].filter((order) => {
        const orderDate = new Date(order.date_order);
        return (
          today.getFullYear() === orderDate.getFullYear() &&
          today.getMonth() === orderDate.getMonth() &&
          today.getDate() === orderDate.getDate()
        );
      });
      this.setState({ temp: filteredOrders });
    }

    if (this.state.Visited !== undefined && this.state.Visited !== null) {
      const filteredOrders1 = this.state.Visited.filter((visit) => {
        const orderDate = new Date(visit.dateIn);
        return (
          today.getFullYear() === orderDate.getFullYear() &&
          today.getMonth() === orderDate.getMonth() &&
          today.getDate() === orderDate.getDate()
        );
      });
      this.setState({ temp1: filteredOrders1 });
    }

    if (this.state.OutVisited !== undefined && this.state.OutVisited !== null) {
      // Build set of client IDs that have a local transaction/invoice
      const transactions = (this.state.UST && this.state.UST[0]) || [];
      const clientsWithTrans = new Set(
        transactions
          .map((o) => {
            if (!o) return null;
            // partner_id may be [id, name] or a single numeric id
            if (Array.isArray(o.partner_id)) return o.partner_id[0];
            if (typeof o.partner_id === "object" && o.partner_id !== null)
              return o.partner_id.id || null;
            return o.partner_id || null;
          })
          .filter((id) => id !== null && id !== undefined)
      );

      const filteredOrders2 = this.state.OutVisited.filter((visit) => {
        const orderDate = new Date(visit.dateVisitIn);
        const sameDay =
          today.getFullYear() === orderDate.getFullYear() &&
          today.getMonth() === orderDate.getMonth() &&
          today.getDate() === orderDate.getDate();
        // Only include visits for which we have a local transaction
        const hasTrans = clientsWithTrans.has(visit.id);
        return sameDay && hasTrans;
      });
      this.setState({ temp2: filteredOrders2 });
    }

    if (this.state.UST[5] !== undefined && this.state.UST[5] !== null) {
      const filteredOrders3 = this.state.UST[5].filter((order) => {
        const orderDate = new Date(order.date_order);
        return (
          today.getFullYear() === orderDate.getFullYear() &&
          today.getMonth() === orderDate.getMonth() &&
          today.getDate() === orderDate.getDate()
        );
      });

      this.setState({ temp3: filteredOrders3 });
    }
    // Update the state with filtered orders
  }

  onSearch = async (text) => {
    var values = await SearchFilterFunction(
      text,
      this.state.clients,
      this.state.clientsCopy,
      this.state.noData
    );
    this.setState({
      clients: values.items,
      noData: values.noData,
      loading: false,
    });
  };

  handlePrint = () => {
    this.printableRef.current.handlePrint();
    this.printable2Ref.current.handlePrint();
  };

  handleItemClick = (id) => {
    // Toggle the selected item
    this.setState((prevState) => ({
      selectedItemId: prevState.selectedItemId === id ? null : id,
    }));
  };

  onSelectFromDate = async (date) => {
    await this.setState({ fromDate: date });
    if (this.state.UST && this.state.UST.length !== 0) {
      let total = 0; // Initialize with the current total

      if (this.state.UST[0] !== undefined && this.state.UST[0] !== null) {
        this.state.UST[0].forEach((order) => {
          var date_test = new Date(order.date_order);
          console.log(date_test.toISOString().split("T")[0]); // Logs the full date in YYYY-MM-DD format

          // Convert this.state.fromDate and this.state.toDate to full dates
          const fromDate = new Date(this.state.fromDate);
          const toDate = new Date(this.state.toDate);

          console.log(fromDate.toISOString().split("T")[0]); // Logs full fromDate in YYYY-MM-DD format
          console.log(toDate.toISOString().split("T")[0]); // Logs full toDate in YYYY-MM-DD format

          // Compare the dates
          if (
            fromDate.toISOString().split("T")[0] <=
              date_test.toISOString().split("T")[0] &&
            toDate.toISOString().split("T")[0] >=
              date_test.toISOString().split("T")[0]
          ) {
            total += parseFloat(order.taxedAmount.replace(/,/g, "")) || 0;
          }
        });
      }

      // Update the state once with the final accumulated total
      this.setState({ Total: total });
    }
    if (
      this.state.UST[1] !== undefined &&
      this.state.UST[1] !== null &&
      this.state.UST[1].length !== 0
    ) {
      let total = 0; // Initialize with the current total

      this.state.UST[1].forEach((order) => {
        var date_test = new Date(order.date_order);
        console.log(date_test.toISOString().split("T")[0]); // Logs the full date in YYYY-MM-DD format

        // Convert this.state.fromDate and this.state.toDate to full dates
        const fromDate = new Date(this.state.fromDate);
        const toDate = new Date(this.state.toDate);

        console.log(fromDate.toISOString().split("T")[0]); // Logs full fromDate in YYYY-MM-DD format
        console.log(toDate.toISOString().split("T")[0]); // Logs full toDate in YYYY-MM-DD format

        // Compare the dates
        if (
          fromDate.toISOString().split("T")[0] <=
            date_test.toISOString().split("T")[0] &&
          toDate.toISOString().split("T")[0] >=
            date_test.toISOString().split("T")[0]
        ) {
         total += parseFloat(order.taxedAmount.replace(/,/g, "")) || 0;
        }
      });

      // Update the state once with the final accumulated total
      this.setState({ TotalRO: total });
    }
    if (this.state.UST[5] !== undefined && this.state.UST[5].length !== 0) {
      let total = 0; // Initialize with the current total

      this.state.UST[5].forEach((order) => {
        var date_test = new Date(order.date_order);
        console.log(date_test.toISOString().split("T")[0]); // Logs the full date in YYYY-MM-DD format

        // Convert this.state.fromDate and this.state.toDate to full dates
        const fromDate = new Date(this.state.fromDate);
        const toDate = new Date(this.state.toDate);

        console.log(fromDate.toISOString().split("T")[0]); // Logs full fromDate in YYYY-MM-DD format
        console.log(toDate.toISOString().split("T")[0]); // Logs full toDate in YYYY-MM-DD format

        // Compare the dates
        if (
          fromDate.toISOString().split("T")[0] <=
            date_test.toISOString().split("T")[0] &&
          toDate.toISOString().split("T")[0] >=
            date_test.toISOString().split("T")[0]
        ) {
          total += parseFloat(order.taxedAmount.replace(/,/g, "")) || 0;
        }
      });

      // Update the state once with the final accumulated total
      this.setState({ TotalCSH: total });
    }
  };

  onSelectToDate = async (date) => {
    await this.setState({ toDate: date });
  };

  // itemSales = async () => {
  //   this.setState({ SR: [] });

  //   if (this.state.UST[0] !== undefined && this.state.UST[0] !== null) {
  //    await this.state.UST[0].map(async(order, index) => {
  //       var date_test = new Date(order.date_order);
  //       console.log(date_test.toISOString().split("T")[0]); // Logs the full date in YYYY-MM-DD format

  //       // Convert this.state.fromDate and this.state.toDate to full dates
  //       const fromDate = new Date(this.state.fromDate);
  //       const toDate = new Date(this.state.toDate);

  //       console.log(fromDate.toISOString().split("T")[0]); // Logs full fromDate in YYYY-MM-DD format
  //       console.log(toDate.toISOString().split("T")[0]);
  //       if (
  //         fromDate.toISOString().split("T")[0] <=
  //           date_test.toISOString().split("T")[0] &&
  //         toDate.toISOString().split("T")[0] >=
  //           date_test.toISOString().split("T")[0]
  //       ) {
  //        await order.Lines.map(async(item) => {
  //           this.state.SalesObject.name = item.name;
  //           this.state.SalesObject.qty = item.product_uom_qty;
  //           this.state.SalesObject.Total = item.price_total;
  //           this.state.SalesObject.date = order.date_order;
  //           let found = this.state.SR.find((f) => f.name === item.name);
  //           if (found) {
  //             found.qty += item.product_uom_qty;
  //             found.Total += item.price_total;
  //           } else {
  //            await this.state.SR.push({
  //               name: item.name,
  //               qty: item.product_uom_qty,
  //               Total: item.price_total,
  //             });
  //           }

  //         });
  //       }

  //       // Logs full toDate in YYYY-MM-DD format
  //       console.log(this.state.SR);
  //       // Compare the dates
  //     });
  //   }
  //   if (this.state.UST[5] !== undefined && this.state.UST[5] !== null) {
  //    await this.state.UST[5].map(async(order, index) => {
  //       var date_test = new Date(order.date_order);
  //       console.log(date_test.toISOString().split("T")[0]); // Logs the full date in YYYY-MM-DD format

  //       // Convert this.state.fromDate and this.state.toDate to full dates
  //       const fromDate = new Date(this.state.fromDate);
  //       const toDate = new Date(this.state.toDate);

  //       console.log(fromDate.toISOString().split("T")[0]); // Logs full fromDate in YYYY-MM-DD format
  //       console.log(toDate.toISOString().split("T")[0]);
  //       if (
  //         fromDate.toISOString().split("T")[0] <=
  //           date_test.toISOString().split("T")[0] &&
  //         toDate.toISOString().split("T")[0] >=
  //           date_test.toISOString().split("T")[0]
  //       ) {
  //       {
  //         await order.Lines.map(async(item) => {
  //           this.state.SalesObject.name = item.name;
  //           this.state.SalesObject.qty = item.product_uom_qty;
  //           this.state.SalesObject.Total = item.price_total;
  //           this.state.SalesObject.date = order.date_order;
  //           let found = this.state.SR.find((f) => f.name === item.name);
  //           if (found) {
  //             found.qty += item.product_uom_qty;
  //             found.Total += item.price_total;
  //           } else {
  //            await this.state.SR.push({
  //               name: item.name,
  //               qty: item.product_uom_qty,
  //               Total: item.price_total,
  //             });
  //           }

  //           // this.state.SR.map((found) => {
  //           //   if (found.name === item.name) {
  //           //     found.qty += item.qty;
  //           //     found.total += item.total;
  //           //   } else {
  //           //     this.state.SR.push();
  //           //   }
  //           // });
  //         });

  //       }

  //       console.log(this.state.SR);
  //     }
  //     this.setState({SR : this.state.SR})
  //       // Compare the dates
  //     });

  //   }
  // };

  itemSales = async () => {
    // Start with empty array
    this.setState({ SR: [] });

    // Create a new array we'll build synchronously
    let newSR = [];

    // Helper function to process orders
    const processOrders = (orders) => {
      if (!orders) return;

      orders.forEach((order) => {
        const orderDate = new Date(order.date_order);
        const fromDate = new Date(this.state.fromDate);
        const toDate = new Date(this.state.toDate);

        // Skip if date is outside range
        if (
          orderDate.toISOString().split("T")[0] <
            fromDate.toISOString().split("T")[0] ||
          orderDate.toISOString().split("T")[0] >
            toDate.toISOString().split("T")[0]
        ) {
          return;
        }

        order.Lines.forEach((item) => {
          const foundIndex = newSR.findIndex((f) => f.name === item.name);

          if (foundIndex >= 0) {
            // Update existing item
            newSR[foundIndex] = {
              ...newSR[foundIndex],
              qty: newSR[foundIndex].qty + item.product_uom_qty,
              freeItem: newSR[foundIndex].freeItem + item.freeItem,
              Total: newSR[foundIndex].Total + item.price_total,
            };
          } else {
            // Add new item
            newSR.push({
              name: item.name,
              qty: item.product_uom_qty,
              Total: item.price_total,
              freeItem : item.freeItem,
              date: order.date_order,
            });
          }
        });
      });
    };

    // Process both UST[0] and UST[5]
    if (this.state.UST[0]) processOrders(this.state.UST[0]);
    if (this.state.UST[5]) processOrders(this.state.UST[5]);

    // Update state once with all changes
    this.setState({ SR: newSR }, () => {
      console.log("Final SR state:", this.state.SR);
    });
  };

  render() {
    if (this.state.loading) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: "4rem", height: "4rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      );
    }
    if (this.state.CurrentId === 0) {
      return (
        <div className="container-fluid v-100" style={stylesASAP.reportcolor}>
          <div className="col">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.props.history.push("./Reports2")}
              color={"#6C757D"}
              height="50px"
              width="50px"
            />
          </div>
          {!this.state.nodata ? null : (
            <div className="col alert alert-danger"> No Data Found !!!</div>
          )}

          <div className="row">
            {" "}
            <label className="h1 text-center  mb-5 ">
              <u>
                <b>{this.state.types[this.state.CurrentId].name}</b>
              </u>
            </label>
          </div>
          <div className="row">
            <div className="col text-center">
              <h6>From Date </h6>
              <DatePicker
                className="form-control"
                selected={this.state.fromDate}
                onChange={(date) => this.onSelectFromDate(date)}
              />
            </div>
            <div className="col text-center">
              <h6>To Date </h6>
              <DatePicker
                className="form-control"
                selected={this.state.toDate}
                onChange={(date) => this.onSelectToDate(date)}
              />
            </div>
          </div>

          {/* Your table component */}

          <div className="table-responsive mt-5" ref={this.printableRef}>
            <div className="table-responsive mt-5 ">
              <div className="text-center">
                <b>SALES ORDER</b>

                <h2 className="float-right"> Total : {this.state.Total}</h2>
              </div>

              <table className="table table-striped">
                <thead>
                  <tr>
                    {this.state.types[this.state.CurrentId].Headers.map(
                      (header, index) => {
                        return <th key={index}>{header}</th>;
                      }
                    )}
                  </tr>
                </thead>
                <tbody>
                  {this.state.UST[0] !== undefined && this.state.UST[0] !== null
                    ? this.state.UST[0].map((order, index) => {
                        var date_test = new Date(order.date_order);

                        // Convert this.state.fromDate and this.state.toDate to full dates
                        const fromDate = new Date(this.state.fromDate);
                        const toDate = new Date(this.state.toDate);

                        // Compare the dates
                        if (
                          fromDate.toISOString().split("T")[0] <=
                            date_test.toISOString().split("T")[0] &&
                          toDate.toISOString().split("T")[0] >=
                            date_test.toISOString().split("T")[0]
                        ) {
                          return (
                            <tr>
                              <td>{order.name}</td>
                              <td>{order.partner_id[1]}</td>
                              <td>{order.taxedAmount}</td>
                            </tr>
                          );
                        }
                      })
                    : null}
                </tbody>
              </table>

              <div className="text-center">
                <b>RETURN ORDER</b>
                <h2 className="float-right"> Total : {this.state.TotalRO}</h2>
              </div>

              <table className="table table-striped">
                <thead>
                  <tr>
                    {this.state.types[this.state.CurrentId].Headers.map(
                      (header, index) => {
                        return <th key={index}>{header}</th>;
                      }
                    )}
                  </tr>
                </thead>
                <tbody>
                  {this.state.UST[1] !== undefined && this.state.UST[1] !== null
                    ? this.state.UST[1].map((order, index) => {
                        var date_test = new Date(order.date_order);

                        const fromDate = new Date(this.state.fromDate);
                        const toDate = new Date(this.state.toDate);

                        // Compare the dates
                        if (
                          fromDate.toISOString().split("T")[0] <=
                            date_test.toISOString().split("T")[0] &&
                          toDate.toISOString().split("T")[0] >=
                            date_test.toISOString().split("T")[0]
                        ) {
                          return (
                            <tr>
                              <td>{order.name}</td>
                              <td>{order.partner_id[1]}</td>
                              <td>{order.taxedAmount}</td>
                            </tr>
                          );
                        }
                      })
                    : null}
                </tbody>
              </table>

              <div className="text-center">
                <b>CASH SALES</b>
                <h2 className="float-right"> Total : {this.state.TotalCSH}</h2>
              </div>

              <table className="table table-striped">
                <thead>
                  <tr>
                    {this.state.types[this.state.CurrentId].Headers.map(
                      (header, index) => {
                        return <th key={index}>{header}</th>;
                      }
                    )}
                  </tr>
                </thead>
                <tbody>
                  {this.state.UST[5] !== undefined &&
                  this.state.UST[5].length !== 0
                    ? this.state.UST[5].map((order, index) => {
                        var date_test = new Date(order.date_order);

                        const fromDate = new Date(this.state.fromDate);
                        const toDate = new Date(this.state.toDate);

                        // Compare the dates
                        if (
                          fromDate.toISOString().split("T")[0] <=
                            date_test.toISOString().split("T")[0] &&
                          toDate.toISOString().split("T")[0] >=
                            date_test.toISOString().split("T")[0]
                        ) {
                          return (
                            <tr>
                              <td>{order.name}</td>
                              <td>{order.partner_id[1]}</td>
                              <td>{order.taxedAmount}</td>
                            </tr>
                          );
                        }
                      })
                    : null}
                </tbody>
              </table>
            </div>
          </div>

          {/* ReactToPrint component */}
          <ReactToPrint
            trigger={() => (
              <button className="btn btn-primary floatRight">Print</button>
            )}
            content={() => this.printableRef.current}
          />
        </div>
      );
    } else if (this.state.CurrentId === 1) {
      return (
        <div className="container-fluid v-100" style={stylesASAP.reportcolor}>
          <div className="col">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.props.history.push("./Reports2")}
              color={"#6C757D"}
              height="50px"
              width="50px"
            />
          </div>
          {!this.state.nodata ? null : (
            <div className="col alert alert-danger"> No Data Found !!!</div>
          )}

          <div className="row">
            {" "}
            <label className="h1 text-center  mb-5 ">
              <u>
                <b>{this.state.types[this.state.CurrentId].name}</b>
              </u>
            </label>
          </div>

          {/* Your table component */}

          <div className="table-responsive mt-5" ref={this.printableRef}>
            <div className="table-responsive mt-5 ">
              <table className="table table-striped">
                <thead>
                  <tr>
                    {this.state.types[this.state.CurrentId].Headers.map(
                      (header, index) => {
                        return <th key={index}>{header}</th>;
                      }
                    )}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Ordered</td>
                    <td>{this.state.temp.length}</td>
                  </tr>
                  <tr>
                    <td>Schedule Visited</td>

                    <td>{this.state.temp1.length}</td>
                  </tr>
                  <tr>
                    <td>Collection</td>
                    <td>{this.state.temp3.length}</td>
                  </tr>
                  <tr>
                    <td>Out of Route Visits</td>
                    <td>{this.state.temp2.length}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* ReactToPrint component */}
          <ReactToPrint
            trigger={() => (
              <button className="btn btn-primary floatRight">Print</button>
            )}
            content={() => this.printableRef.current}
          />
        </div>
      );
    } else if (this.state.CurrentId === 2) {
      return (
        <div className="container-fluid v-100" style={stylesASAP.reportcolor}>
          <div className="col">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.props.history.push("./Reports2")}
              color={"#6C757D"}
              height="50px"
              width="50px"
            />
          </div>
          {!this.state.nodata ? null : (
            <div className="col alert alert-danger"> No Data Found !!!</div>
          )}

          <div className="row">
            {" "}
            <label className="h1 text-center  mb-5 ">
              <u>
                <b>{this.state.types[this.state.CurrentId].name}</b>
              </u>
            </label>
          </div>

          <div className="row">
            <div className="col text-center">
              <h6>From Date </h6>
              <DatePicker
                className="form-control"
                selected={this.state.fromDate}
                onChange={(date) => this.onSelectFromDate(date)}
              />
            </div>
            <div className="col text-center">
              <h6>To Date </h6>
              <DatePicker
                className="form-control"
                selected={this.state.toDate}
                onChange={(date) => this.onSelectToDate(date)}
              />
            </div>
          </div>
          {/* Your table component */}

          <div className="table-responsive mt-5" ref={this.printableRef}>
            <div className="table-responsive mt-5 ">
              <div className="text-center">
                <b>RECEIPT</b>
              </div>

              <table className="table table-striped">
                <thead>
                  <tr>
                    {this.state.types[this.state.CurrentId].Headers.map(
                      (header, index) => {
                        return <th key={index}>{header}</th>;
                      }
                    )}
                  </tr>
                </thead>
                <tbody>
                  {this.state.UST[3] !== undefined && this.state.UST[3] !== null
                    ? this.state.UST[3].map((order, index) => {
                        var date_test = new Date(order.date_order);

                        const fromDate = new Date(this.state.fromDate);
                        const toDate = new Date(this.state.toDate);

                        // Compare the dates
                        if (
                          fromDate.getTime() <= date_test.getTime() &&
                          toDate.getTime() >= date_test.getTime()
                        ) {
                          return (
                            <tr>
                              <td>{order.name}</td>
                              <td>{order.name}</td>
                              <td>{order.partner_id[1]}</td>
                              <td>{order.taxedAmount}</td>
                            </tr>
                          );
                        }
                      })
                    : null}
                </tbody>
              </table>
            </div>
          </div>

          {/* ReactToPrint component */}
          <ReactToPrint
            trigger={() => (
              <button className="btn btn-primary floatRight">Print</button>
            )}
            content={() => this.printableRef.current}
          />
        </div>
      );
    } else if (this.state.CurrentId === 3) {
      return (
        <div className="container-fluid v-100" style={stylesASAP.reportcolor}>
          <div className="col">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.props.history.push("./Reports2")}
              color={"#6C757D"}
              height="50px"
              width="50px"
            />
          </div>
          {!this.state.nodata ? null : (
            <div className="col alert alert-danger"> No Data Found !!!</div>
          )}

          <div className="row">
            {" "}
            <label className="h1 text-center  mb-5 ">
              <u>
                <b>{this.state.types[this.state.CurrentId].name}</b>
              </u>
            </label>
          </div>
          <div className="row">
            <div className="col text-center">
              <h6>From Date </h6>
              <DatePicker
                className="form-control"
                selected={this.state.fromDate}
                onChange={(date) => this.onSelectFromDate(date)}
              />
            </div>
            <div className="col text-center">
              <h6>To Date </h6>
              <DatePicker
                className="form-control"
                selected={this.state.toDate}
                onChange={(date) => this.onSelectToDate(date)}
              />
            </div>
          </div>
          {/* Your table component */}

          <div className="table-responsive mt-5" ref={this.printableRef}>
            <div className="table-responsive mt-5 ">
              <table className="table table-striped">
                <thead>
                  <tr>
                    {this.state.types[this.state.CurrentId].Headers.map(
                      (header, index) => {
                        return <th key={index}>{header}</th>;
                      }
                    )}
                  </tr>
                </thead>
                <tbody>
                  {this.state.temp2 !== undefined &&
                  this.state.temp2 !== null
                    ? this.state.temp2.map((order, index) => {
                        var date_test = new Date(order.dateVisitIn);

                        // Convert this.state.fromDate and this.state.toDate to full dates
                        const fromDate = new Date(this.state.fromDate);
                        const toDate = new Date(this.state.toDate);

                        // Compare the dates
                        if (
                          fromDate.toISOString().split("T")[0] <=
                            date_test.toISOString().split("T")[0] &&
                          toDate.toISOString().split("T")[0] >=
                            date_test.toISOString().split("T")[0]
                        ) {
                          return (
                            <tr>
                              {/* <td>{order.code}</td> */}
                              <td>{order.name}</td>
                              <td>
                                {order.dateVisitIn + " " + order.timeVisitIn}
                              </td>
                              <td>
                                {order.dateVisitOut + " " + order.timeVisitOut}
                              </td>
                              <td>{order.visit}</td>
                            </tr>
                          );
                        }
                      })
                    : null}
                </tbody>
              </table>
            </div>
          </div>

          {/* ReactToPrint component */}
          <ReactToPrint
            trigger={() => (
              <button className="btn btn-primary floatRight">Print</button>
            )}
            content={() => this.printableRef.current}
          />
        </div>
      );
    } else if (this.state.CurrentId === 4) {
      return (
        <div className="container-fluid v-100" style={stylesASAP.reportcolor}>
          <div className="col">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.props.history.push("./Reports2")}
              color={"#6C757D"}
              height="50px"
              width="50px"
            />
          </div>
          {!this.state.nodata ? null : (
            <div className="col alert alert-danger"> No Data Found !!!</div>
          )}

          <div className="row">
            {" "}
            <label className="h1 text-center  mb-5 ">
              <u>
                <b>{this.state.types[this.state.CurrentId].name}</b>
              </u>
            </label>
          </div>
          <div className="row">
            <div className="col text-center">
              <h6>From Date </h6>
              <DatePicker
                className="form-control"
                selected={this.state.fromDate}
                onChange={(date) => this.onSelectFromDate(date)}
              />
            </div>
            <div className="col text-center">
              <h6>To Date </h6>
              <DatePicker
                className="form-control"
                selected={this.state.toDate}
                onChange={(date) => this.onSelectToDate(date)}
              />
            </div>
          </div>
          {/* Your table component */}

          <div className="table-responsive mt-5" ref={this.printableRef}>
            <div className="table-responsive mt-5 ">
              <table className="table table-striped">
                <thead>
                  <tr>
                    {this.state.types[this.state.CurrentId].Headers.map(
                      (header, index) => {
                        return <th key={index}>{header}</th>;
                      }
                    )}
                  </tr>
                </thead>
                <tbody>
                  {this.state.scheduledReport !== undefined &&
                  this.state.scheduledReport !== null
                    ? this.state.scheduledReport.map((order, index) => {
                        var date_test = new Date(order.dateIn);
                        // Convert this.state.fromDate and this.state.toDate to full dates
                        const fromDate = new Date(this.state.fromDate);
                        const toDate = new Date(this.state.toDate);

                        // Compare the dates
                        if (
                          fromDate.toISOString().split("T")[0] <=
                            date_test.toISOString().split("T")[0] &&
                          toDate.toISOString().split("T")[0] >=
                            date_test.toISOString().split("T")[0]
                        ) {
                          return (
                            <tr>
                              {/* <td>{order.code}</td> */}
                              <td>{order.name}</td>
                              <td>{order.dateIn + " " + order.timeIn}</td>
                              <td>{order.dateOut + " " + order.timeOut}</td>
                              <td>{order.visit}</td>
                              <td>{order.countTrans}</td>
                            </tr>
                          );
                        }
                      })
                    : null}
                </tbody>
              </table>
            </div>
          </div>

          {/* ReactToPrint component */}
          <ReactToPrint
            trigger={() => (
              <button className="btn btn-primary floatRight">Print</button>
            )}
            content={() => this.printableRef.current}
          />
        </div>
      );
    } else if (this.state.CurrentId === 5) {
      return (
        <div className="container-fluid v-100" style={stylesASAP.reportcolor}>
          <div className="col">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.props.history.push("./Reports2")}
              color={"#6C757D"}
              height="50px"
              width="50px"
            />
          </div>
          {!this.state.nodata ? null : (
            <div className="col alert alert-danger"> No Data Found !!!</div>
          )}

          <div className="row">
            {" "}
            <label className="h1 text-center  mb-5 ">
              <u>
                <b>{this.state.types[this.state.CurrentId].name}</b>
              </u>
            </label>
          </div>
          <div className="row">
            <div className="col text-center">
              <h6>From Date </h6>
              <DatePicker
                className="form-control"
                selected={this.state.fromDate}
                onChange={(date) => this.onSelectFromDate(date)}
              />
            </div>
            <div className="col text-center">
              <h6>To Date </h6>
              <DatePicker
                className="form-control"
                selected={this.state.toDate}
                onChange={(date) => this.onSelectToDate(date)}
              />
            </div>
          </div>
          {/* Your table component */}
          <div
            className="btn btn-primary float-right mt-2"
            onClick={() => this.itemSales()}
          >
            Get Data
          </div>
          <div className="table-responsive mt-5" ref={this.printableRef}>
            <div className="table-responsive mt-5 ">
              <div className="text-center">
                <b>ITEM SALES</b>
              </div>

              <table className="table table-striped">
                <thead>
                  <tr>
                    {this.state.types[this.state.CurrentId].Headers.map(
                      (header, index) => {
                        return <th key={index}>{header}</th>;
                      }
                    )}
                  </tr>
                </thead>
                <tbody>
                  {this.state.SR.map((last) => {
                    return (
                      <tr>
                        <td>{last.name}</td>
                        <td>{last.qty}</td>
                        <td>{last.freeItem}</td>
                        {/* <td> {Number(last.Total).toFixed(2)}</td> */}
                        <td> {Number.isFinite(Number(last?.Total))
    ? Number(last.Total).toFixed(2)
    : "0.00"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* ReactToPrint component */}
          <ReactToPrint
            trigger={() => (
              <button className="btn btn-primary floatRight">Print</button>
            )}
            content={() => this.printableRef.current}
          />
        </div>
      );
    } else if (this.state.CurrentId === 6) {
      return (
        <div className="container-fluid v-100" style={stylesASAP.reportcolor}>
          <div className="col">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.props.history.push("./Reports2")}
              color={"#6C757D"}
              height="50px"
              width="50px"
            />
          </div>

          <div className="row">
            <label className="h1 text-center  mb-5 ">
              <u>
                <b>Competitor Logs</b>
              </u>
            </label>
          </div>

          <div className="table-responsive mt-5" ref={this.printableRef}>
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                   <th>Competitor</th>
                   <th>Our Product</th>
                   <th>Product</th>
                  <th>Shelf %</th>
                  <th>Price</th>
                  <th>Promotions</th>
                  <th>Notes</th>
                  <th>Logged At</th>
                </tr>
              </thead>
              <tbody>
                {this.state.competitorLogs.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center text-muted">
                      No competitor logs found.
                    </td>
                  </tr>
                ) : (
                  this.state.competitorLogs.map((log, index) => (
                    <tr key={index}>
                      <td>{log.competitorName || "-"}</td>
                      <td>{log.shopItemName || log.shopItem || "-"}</td>
                      <td>{log.productName || "-"}</td>
                      <td>{log.shelfShare || 0}%</td>
                      <td>{log.price || 0}</td>
                      <td>{Array.isArray(log.promotions) && log.promotions.length ? log.promotions.join(", ") : "-"}</td>
                      <td>{log.notes || "-"}</td>
                      <td>{log.timestamp ? new Date(log.timestamp).toLocaleString() : "-"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <ReactToPrint
            trigger={() => (
              <button className="btn btn-primary floatRight">Print</button>
            )}
            content={() => this.printableRef.current}
          />
        </div>
      );
    }
  }
}
